import { TableCellsIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const RisksModuleSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label icon={TableCellsIcon} id="risks-module-label" htmlFor="risks-module">
        Risks module
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="risks-module"
          aria-labelledby="risks-module-label"
          isSelected={organization.is_risks_module_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_risks_module_enabled: !organization.is_risks_module_enabled,
                  ...(organization.is_risks_module_enabled && {
                    is_risk_approval_workflows_enabled: false,
                  }),
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
